<template>
    <div>
      <q-card :data-cy="dataCy" class="container_box shadow-1">
        <div @click="openURL" :class="this.servicio.url ? ['clickable cursor-pointer'] : ''">
        <div
          class="row"
          style="height: 94px; max-height: 85px; padding: 16px 16px 0 16px"
        >
        <div class="col-12" style="display: flex;">
          <div class="containerLogo">
            <q-img :src="imgLogotipo" contain class="logotipo"/>
          </div>
          <div class="TextName" data-cy="service-title">
            {{ datos.name }}
          </div>
        </div>
        </div>
        <div
          class="espacios TextDescription"
          style="margin-left: 16px; margin-right: 10px; height: 70px; padding: 5px;"
        >
          {{ datos.description }}
        </div>
        <div class="col-12 row imagenContainer">
          <q-img :src="imgImagen" width="100%" height="181px" class="Imagen">
          </q-img>
        </div>
      </div>
      <div class="absolute-bottom Rectangle"  >
        <div class="col-12 row footerContainer">
        </div>
      </div>
      </q-card>
    </div>
  </template>
<script>
import Formats from '@/components/shared/mixins/Formats.js';
import { QCard, QImg } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  props: {
    datos: Object,
    dataCy: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      servicio: null,
      imgImagen: null,
      urlServicio: null,
      imgLogotipo: null
    };
  },
  mixins: [Formats, Resources],
  computed: {

  },
  methods: {
    openURL () {
      if (this.servicio.url) {
        window.open(this.servicio.url, '_blank');
      }
    },
    async refillData () {
      let resources = this.servicio.resources;
      let imagen = this.searchResource(resources, 'Imagen');
      let logotipo = this.searchResource(resources, 'Logotipo');
      this.urlServicio = this.servicio.hasOwnProperty('url') && this.servicio.url !== '' ? this.servicio.url : null;
      this.imgImagen =
        imagen !== null ? imagen.url : this.getDefaultResource('Imagen');
      this.imgLogotipo =
        logotipo !== null ? logotipo.url : this.getDefaultResource('Logotipo');
    }
  },
  components: {
    QCard, QImg
  },
  watch: {
    datos: {
      handler: function () {
        this.servicio = this.datos;
        if (Object.entries(this.datos).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container_box {
  &.clickable {
    transition: box-shadow 0.3s;
    &:hover {
      box-shadow: $shadow-8;
    }
  }
  padding: 0 !important;
  height: 336px;
  background-color: #ffffff;
}

.containerLogo {
  margin-top: 3px;
  padding-right: 15px;
}

.paddingInfo {
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
}

.logotipo {
  width: 40px;
  height: 40px;
}

.imageContainer {
  height: 71px;
  max-height: 71px;
}
.Imagen {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.Rectangle {
  width: 100%;
  height: 43px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 7px 16px 0 16px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.TextName {
  font-family: DINPro;
  font-size: 19px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  color: rgb(0, 47, 108);
}
.TextDescription {
  font-family: DINPro;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.21px;
  color: black;
}
.Informacion {
  width: 20px;
  height: 20px;
  color: rgba(0, 0, 0, 64);
}
.error-img {
  background-color: #eeeeee;
  color: #9c9c9c;
}
.footerContainer{
  float: right;
}
</style>
